import * as types from "./actionTypes"

export function setError(data) {
    return {
        type: types.SET_ERROR,
        payload: data,
    }
}

export function clearError() {
    return {
        type: types.CLEAR_ERROR,
    }
}
